import { CONTACT_EMAIL } from "../../data/constants";
import { appsJa } from "../../data/apps";
import type { UserInfo } from "../types";

export const user: UserInfo = {
	main: {
		title: "Shimomura Kazumasa",
		name: "下村 一将",
		email: CONTACT_EMAIL,
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/_kzumu",
		github: "https://github.com/s2mr",
		linkedin: "https://www.linkedin.com/in/s2mr/",
		facebook: "https://www.facebook.com/kaz.s2mr/",
		reddit: "https://www.reddit.com/user/kzumu"
	},

	homepage: {
		name: "下村一将",
		hurigana: "Shimomura Kazumasa",
		description: `
            iOS開発を主軸に、バックエンド・インフラまで幅広く手がけるソフトウェアエンジニアです。
            サイバーエージェントにて大規模ライブ配信アプリ「CL」の立ち上げから運用まで担当。
            新規iOSアプリの0→1開発を複数経験し、ユーザー体験を重視したアプリケーション設計を得意としています。
            2017年から継続的に個人開発を行い、累計20以上のアプリを公開・運用中。Node.js/TypeScriptでのバックエンド開発、GCP/AWSでのインフラ構築・運用も担当し、フルスタック開発を実践しています。
        `,
	},

	about: {
		title: "iOSを軸に、プロダクトを端から端までつくる。",
		description:
			"サイバーエージェントにて、大規模配信プラットフォームのiOSアプリケーション開発とアーキテクチャ設計に従事。モジュラーアーキテクチャ、GraphQL、AI統合など、最新技術を活用した高品質なアプリケーション開発を専門としています。個人開発では累計20以上のアプリを公開し、多くはオープンソースとして貢献しています。",
	},

	outputs: {
		title: "アウトプット",
		description:
			"開発で得た知見や、プラクティスなどは記事として公開しています。",
	},

	techStack: {
		title: "Tech Stack & Skills",
		description: "実務・個人開発で使用している技術スタックとスキルセット",
		languages: [
			{
				name: "Swift",
				level: "Expert",
				yearsOfExperience: "7+",
				icon: "🍎",
				color: "#FA7343",
				description: "iOS開発のメイン言語。7年以上の実務経験。Swift Concurrency、Combineを駆使した高品質なアプリケーション開発。",
				frameworks: [
					"SwiftUI",
					"UIKit",
					"Combine",
					"Swift Concurrency (async/await)",
					"MessageKit",
					"WidgetKit"
				],
				tools: [
					"Xcode",
					"Tuist",
					"Swift Package Manager",
					"CocoaPods",
					"Carthage",
					"Scipio",
					"Fastlane"
				],
				libraries: [
					"AVFoundation",
					"CoreData",
					"Realm",
					"Firebase SDK",
					"Alamofire",
					"Lottie",
					"SwiftSoup"
				],
				testing: ["XCTest", "XCUITest"],
				architecture: ["MVVM", "Flux/Redux", "Clean Architecture", "モジュラーアーキテクチャ", "Repository Pattern"]
			},
			{
				name: "TypeScript",
				level: "Advanced",
				yearsOfExperience: "5+",
				icon: "📘",
				color: "#3178C6",
				description: "バックエンド・Web開発で使用。TypeSpec/OpenAPIによる型安全な開発、Cloud Run/Cloud Functions/AWS Lambdaでのサーバーレス開発。",
				frameworks: [
					"Node.js",
					"Express.js",
					"Fastify",
					"React",
					"Next.js"
				],
				tools: [
					"TypeSpec/OpenAPI",
					"Prisma",
					"ESLint",
					"Prettier",
					"ts-node",
					"pnpm"
				],
				libraries: [
					"GraphQL (PostGraphile)",
					"Zod",
					"Axios",
					"LangChain",
					"AI SDK (Vercel)",
					"Firebase Admin SDK",
					"Firecrawl"
				],
				testing: ["Jest", "Supertest", "ts-jest"],
				architecture: ["Microservices", "Repository Pattern", "Clean Architecture", "Serverless"]
			},
			{
				name: "Dart",
				level: "Intermediate",
				yearsOfExperience: "2+",
				icon: "🎯",
				color: "#0175C2",
				description: "Flutter開発でクロスプラットフォームアプリケーション開発に使用。",
				frameworks: [
					"Flutter"
				],
				tools: [
					"Pub",
					"Flutter DevTools"
				],
				libraries: [
					"Provider",
					"Riverpod",
					"Freezed"
				],
				testing: ["Flutter Test", "Mockito"],
				architecture: ["MVVM", "BLoC Pattern"]
			},
			{
				name: "Go",
				level: "Intermediate",
				yearsOfExperience: "2+",
				icon: "🐹",
				color: "#00ADD8",
				description: "マイクロサービス・CLIツール開発で使用。",
				frameworks: [
					"gRPC",
					"Echo"
				],
				tools: [
					"Go Modules",
					"Task"
				],
				libraries: [
					"Protocol Buffers",
					"GORM"
				],
				testing: ["Testing Package", "Testify"],
				architecture: ["Microservices", "Clean Architecture"]
			}
		],
		platforms: [
			{
				name: "iOS",
				icon: "📱",
				technologies: ["Swift", "SwiftUI", "Combine", "Swift Concurrency", "WidgetKit", "Tuist"]
			},
			{
				name: "Backend",
				icon: "⚙️",
				technologies: ["Node.js", "TypeScript", "Express.js", "GraphQL", "Prisma", "TypeSpec"]
			},
			{
				name: "Web",
				icon: "🌐",
				technologies: ["React", "Next.js", "TypeScript", "Styled Components"]
			},
			{
				name: "GCP",
				icon: "☁️",
				technologies: ["Cloud Run", "Cloud Functions", "Cloud Storage", "Cloud Tasks", "Cloud SQL", "Cloud Build"]
			},
			{
				name: "AWS",
				icon: "🔶",
				technologies: ["Lambda", "CDK", "Serverless Express"]
			},
			{
				name: "AI/ML",
				icon: "🤖",
				technologies: ["Google Gemini API", "OpenAI API", "LangChain", "Cloud TTS", "Firecrawl"]
			}
		],
		databases: [
			{ name: "Realm", type: "Mobile Database", icon: "📦" },
			{ name: "PostgreSQL", type: "Relational DB", icon: "🐘" },
			{ name: "Firestore", type: "NoSQL", icon: "🔥" },
			{ name: "Cloud SQL", type: "Managed SQL", icon: "☁️" }
		],
		devOps: [
			"Docker",
			"Cloud Build",
			"GitHub Actions",
			"Fastlane",
			"Taskfile",
			"AWS CDK",
			"CI/CD"
		],
		other: [
			"HLS Streaming",
			"FFmpeg",
			"WebSocket",
			"Push Notifications",
			"In-App Purchase",
			"App Store Connect API",
			"Firebase (Crashlytics, Analytics, Remote Config, App Check)",
			"gRPC",
			"Protocol Buffers"
		]
	},

	projects: {
		tools: {
			title: "Open Source Tools & Libraries",
			description: "iOS開発の生産性向上を目指したツール群を開発・公開。",
			items: [
				{
					title: "L10nLint",
					description: "Swift製のローカライゼーションリンター。Localizable.stringsの品質管理を自動化し、多言語対応アプリの開発効率を向上。",
					logo: null,
					linkText: "View Project",
					link: "https://github.com/s2mr/L10nLint",
				},

				{
					title: "xc",
					description:
						"Xcodeバージョン管理CLIツール。複数バージョンのXcodeを簡単に切り替え可能にし、プロジェクト間のスムーズな移行を支援。",
					logo: null,
					linkText: "View Project",
					link: "https://github.com/s2mr/xc",
				},
			],
		},

		app: {
			title: "Apps",
			description: "学習・試験対策系を除く、現在公開中・過去に公開した個人開発アプリを掲載。iOSを中心に、macOSやマルチプラットフォームのプロダクトも継続的に開発・運用。",
			items: appsJa,
		},

		subwork: {
			title: "External Projects & Consulting",
			description: "技術顧問・外部開発案件における0→1フェーズの立ち上げ支援。",
			items: [
				{
					title: "MUFASA Technology",
					terms: "2019 - Present",
					description: "技術顧問。iOSアプリ「Follop」の開発・メンテナンス、ハイブランドECサイト向けShopify在庫連携システム開発を担当。複数倉庫の在庫を自動同期するリアルタイム在庫管理システムをNode.js + Shopify APIで実装。",
					logo: "",
					linkText: "View Project",
					link: "https://hidetokyo.jp/",
				},
				{
					title: "Caravelle Inc.",
					terms: "2022/05 - Present",
					description: "iOSアプリ新規開発。SwiftUI + Combineによるモダンアーキテクチャでの実装。0→1フェーズのプロダクト開発を主導。",
					logo: "",
					linkText: "View Company",
					link: "https://caravelle-inc.tokyo/",
				},
				{
					title: "Replive Inc.",
					terms: "2023/05 - 2024/05",
					description: "技術顧問。技術選定、アーキテクチャ設計、新規事業立ち上げ支援。iOS/バックエンドのフルスタック技術支援を提供。",
					logo: "",
					linkText: "View Company",
					link: "https://replive.jp/",
				},
				{
					title: "Motoyui Inc. - RecHub",
					terms: "2022",
					description:
						"採用特化型動画共有プラットフォームの新規開発。フロントエンド・バックエンドの設計・実装を担当。",
					logo: "",
					linkText: "View Company",
					link: "https://motoyui.com/",
				},
				{
					title: "Ricecurry Inc. - 早押し韓国クイズ",
					terms: "2021",
					description:
						"リアルタイムマルチプレイクイズアプリの0→1開発。Firebase Realtime Databaseを活用したマッチング機能、AIボット対戦システムを実装。",
					logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/d9/8c/14/d98c142b-ae2b-6628-b6db-a0c8f1cb047b/AppIcon-0-0-1x_U007emarketing-0-0-0-6-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/460x0w.webp",
					linkText: "View on App Store",
					link: "https://apps.apple.com/jp/app/id1544608791",
				},
				{
					title: "Arriv Inc.",
					terms: "2020",
					description: "iOS新規アプリケーション開発。UI/UX設計からリリースまで一貫して担当。",
					logo: "",
					linkText: "",
					link: "",
				},
				{
					title: "Yenom Inc. - Bitcoin Wallet",
					terms: "2018",
					description:
						"Bitcoinウォレットアプリ及びBitcoinKitライブラリの保守・機能追加。暗号通貨関連の技術習得。",
					logo: "",
					linkText: "View on GitHub",
					link: "https://github.com/yenom",
				},
				{
					title: "Mamorio Inc.",
					terms: "2017",
					description: "IoTデバイス連携アプリの開発支援。BLE通信実装の経験を積む。",
					logo: "",
					linkText: "",
					link: "",
				},
				{
					title: "PicApp Inc. - Teller",
					terms: "2017",
					description: "サマーインターンシップ。Tellerの機能開発に従事。",
					logo: "",
					linkText: "",
					link: "",
				},
				{
					title: "Wantedly Inc.",
					terms: "2017",
					description: "サマーインターンシップ。iOS開発チームにてアプリケーション開発に参加。",
					logo: "",
					linkText: "",
					link: "",
				},
				{
					title: "Milldea LLC.",
					terms: "2016",
					description: "iOS開発アルバイト。実務での開発経験の第一歩。",
					logo: "",
					linkText: "",
					link: "",
				}
			],
		},
	},

	talks: {
		title: "登壇実績",
		description: "技術カンファレンスでの登壇・発表実績",
		items: [
			{
				title: "7カ国語、各ファイル1200行を超えるローカライズを安全に運用する方法",
				event: "iOSDC Japan 2023",
				date: "2023/09/02",
				link: "https://fortee.jp/iosdc-japan-2023/proposal/6c6d45d4-376a-42c6-8210-cca3c329025a",
				description: "ローカライズファイルの静的検査ツール「L10nLint」の開発と運用について発表。7カ国語対応、1200行を超えるローカライズファイルの品質管理を自動化する手法を紹介。",
			},
		],
	},
};
